import React from "react";

import MainLayout from "@components/MainLayout";

import TermsContainer from "../../components/TermsContainer";
import terms from "../../data/terms";

const TermsPage = () => <TermsContainer data={terms} />;

TermsPage.Layout = MainLayout;

export default TermsPage;
